<template>
  <div>
    <div class="container-fluid px-0">
      <div class="d-flex flex-column flex-lg-row">
        <div class="order-2 order-lg-1 col-lg-7 px-0 bg-wolf">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="thanks">
                  <div class="text-center">
                    <a href="/">
                      <img
                        class="thanks__logo"
                        src="../assets/images/logo.svg"
                        alt
                      />
                    </a>
                  </div>
                  <h1 v-if="loaderVisible" class="thanks__headline">
                    Już prawie, już tuż-tuż!<br />Płatność jest w trakcie realizacji... :)
                  </h1>
                  <div v-if="loaderVisible" class="loading">
                  <!--   TODO add smoe loader -->
                  </div>
                  <div v-if="errorVisible" class="text-center py-5">
                    <h3>
                      <span v-html="content.data.pendingPage.error_0"></span>
                      <br />
                      <span v-html="content.data.pendingPage.error_1"></span>
                    </h3>
                    <div><a class="thanks__button" href="/">Powrót</a></div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
        <div class="order-1 order-lg-1 col-lg-5 px-0">
           <img
                src="../assets/images/wolf/wolf_bg.jpg"
                class="form__video d-none d-lg-block"
        />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  name: "Pending",
  inject: ["content"],
  data() {
    return {
      title: "Pending",
      loaderVisible: true,
      errorVisible: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.loaderVisible = false;
      this.errorVisible = true;
    }, 60000);
    setTimeout(() => {
      window.scroll({
        top: 0,
        left: 0,
      });
    }, 1000);
  },
  components: {
    Footer,
  },
};
</script>
<style lang="scss">
.loading {
  text-align: center;
  margin-top: 2rem;
  &__bee {
    animation: bee_opacity 1.4s infinite;
    animation-fill-mode: both;
    margin-right: 0.5rem;

    &--2 {
      animation-delay: 0.2s;
    }
    &--3 {
      animation-delay: 0.4s;
    }
  }
}
@keyframes bee_opacity {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
}
h3 {
  font-family: "Paytone One", sans-serif;
  color: #373737;
}
.thanks__button {
  color: #fff;
  font-family: Paytone One, sans-serif;
  font-size: 0.875rem;
  letter-spacing: 1.4px;
  background-color: #c50c81;
  box-shadow: 1px 2px 0 #000;
  border-radius: 50px;
  padding: 0.625rem 1.95rem;
  text-align: center;
  display: inline-block;
  margin-top: 1rem;
  margin-bottom: 1rem;
  &:hover,
  &:visited {
    cursor: pointer;
    color: #fff;
  }
}
</style>
